import { StyledSection } from './Section.styled';

export default function Section({ children }) {
  return <StyledSection>{children}</StyledSection>;
}
